import React, { useState, useEffect, useContext } from "react";
import "./css/VariantCountKOT.css";
import Back from "./images/icons/backSpace.png";
import Close from "./images/icons/delete.png";
import { DineContext } from "./DineContext";
import { DBContext } from "./DBContext";
import Rupee1 from "./images/MenuReg/rupeeWhite.png";
import minus from "./images/icons/minus.png";
import plus from "./images/icons/plus.png";
import axios from "axios";

function VariantCountKOT({ id, savedCount, selectedItems, remainingStock, onClose, onSave, productionMap, prodSettings, products = [] }) {
	const api_base_url = process.env.REACT_APP_API_BASE_URL;

	const { logginedDB, customerCode, userType } = useContext(DBContext);

	const { alreadySelectedVariants, setAlreadySelectedVariantsFunc } =
		useContext(DineContext);

	//(alreadySelectedVariants);

	const [hovered, setHovered] = useState(null);
	const [countsVKOT, setCount] = useState(savedCount || 1);
	const [productsRecieved, setProductsRecieved] = useState([]);
	const [varientsArray, setVarientsArray] = useState([]);
	const [selectedVariant, setSelectedVariant] = useState(null);
	const [showVariantModal, setShowVariantModal] = useState(false);

	useEffect(() => {
		if (id !== null) {
			setProductsRecieved(id);

			// Check if `varients` exists and is an array
			const variants = Array.isArray(id.varients) ? id.varients : [];
			setVarientsArray(variants);

			if (variants.length > 0) {
				setShowVariantModal(true);
			}
		}
	}, [id]);

	const handleVariantSelect = (variant) => {
		// Check if there is already an item with matching productId and variantId
		const isItemAlreadySelected = selectedItems.some(
			(item) =>
				item.productId === id.id_productReg &&
				item.varientId === variant.variantId
		);

		if (isItemAlreadySelected) {
			alert("This item with the selected variant is already in the list!");
			return;
		}

		setSelectedVariant(variant);
		setShowVariantModal(false);
	};

	// const handleOnClickCount = (num) => {
	//     if (!selectedVariant && varientsArray.length > 0) {
	//         alert("Please select a variant first!");
	//         return;
	//     }

	//     if (num === 10) {
	//         const newCount = parseInt(countsVKOT, 10) + 10;
	//         setCount(newCount);
	//     } else if (num === 20) {
	//         const newCount = parseInt(countsVKOT, 10) + 20;
	//         setCount(newCount);
	//     } else if (num === "zero") {
	//         setCount(0);
	//     } else if (num === "back") {
	//         const newCountStr = countsVKOT.toString().slice(0, -1);
	//         const newCount = newCountStr === "" ? 0 : parseInt(newCountStr, 10);
	//         setCount(newCount);
	//     } else {
	//         if (countsVKOT == 0) {
	//             setCount(countsVKOT + num);
	//         } else {
	//             setCount((prev) => prev + num.toString());
	//         }
	//     }
	// };

	// const handleOnChangeCount = (e) => {
	// 	const value = parseInt(e.target.value);
	// 	setCount(value);
	// };

	// const handleFocus = () => {
	// 	if (countsVKOT === 0) {
	// 		setCount('')
	// 	}
	// }

	// const handleBlur = () => {
	// 	if (countsVKOT === '') {
	// 		setCount(1)
	// 	}
	// }

	// state
	// const [countsVKOT, setCount] = useState(savedCount || 1);
	const [isFirstInput, setIsFirstInput] = useState(true);

	const getDynamicRemainingStock = () => {
		if (!id) return Infinity;
		if (!prodSettings || prodSettings.enable_production_tracking === '0') {
			return Infinity;
		}

		if (prodSettings.exempt_categories && id.category) {
			const exemptCategories = prodSettings.exempt_categories.split(',').filter(Boolean);
			if (exemptCategories.includes(id.category)) {
				return Infinity;
			}
		}

		if (prodSettings.exempt_items) {
			const exemptItems = prodSettings.exempt_items.split(',').filter(Boolean);
			if (exemptItems.includes(String(id.id_productReg))) {
				return Infinity;
			}
		}

		const targetPoolId = id.production_link_item_id || id.id_productReg;
		const prodInfo = productionMap ? productionMap[targetPoolId] : null;
		if (!prodInfo) {
			return remainingStock !== undefined ? remainingStock : Infinity;
		}
		
		if (prodInfo.is_active === 0 || prodInfo.is_active === false) {
			return 0;
		}

		const variantId = selectedVariant ? selectedVariant.variantId : null;
		
		const otherSelectedDeduction = selectedItems
			.reduce((sum, item) => {
				// Skip the current variant we are currently configuring
				if (item.productId === id.id_productReg && (String(item.varientId) === String(variantId) || (variantId === null && !item.varientId))) {
					return sum;
				}

				const itemProduct = products.find(p => p.id_productReg === item.productId);
				if (!itemProduct) return sum;

				const itemPoolId = itemProduct.production_link_item_id || itemProduct.id_productReg;
				if (itemPoolId !== targetPoolId) return sum;

				let factor = 1.0;
				if (item.varientId && itemProduct.varients) {
					const variant = itemProduct.varients.find(v => String(v.variantId) === String(item.varientId));
					if (variant && variant.deductionFactor !== undefined && variant.deductionFactor !== null) {
						factor = parseFloat(variant.deductionFactor);
					}
				}
				return sum + ((item.quantity || 0) * factor);
			}, 0);

		let currentFactor = 1.0;
		if (variantId && id.varients) {
			const variant = id.varients.find(v => String(v.variantId) === String(variantId));
			if (variant && variant.deductionFactor !== undefined && variant.deductionFactor !== null) {
				currentFactor = parseFloat(variant.deductionFactor);
			}
		}

		const allowedPortions = prodInfo.available_qty - otherSelectedDeduction;
		return Math.floor(allowedPortions / currentFactor);
	};

	const currentRemainingStock = getDynamicRemainingStock();

	// handle numpad clicks
	const handleOnClickCount = (num) => {
		if (!selectedVariant && varientsArray.length > 0) {
			alert("Please select a variant first!");
			return;
		}

		let nextCount;
		if (num === 10) {
			nextCount = parseInt(countsVKOT, 10) + 10;
		} else if (num === 20) {
			nextCount = parseInt(countsVKOT, 10) + 20;
		} else if (num === "zero") {
			nextCount = 0;
		} else if (num === "back") {
			const newCountStr = countsVKOT.toString().slice(0, -1);
			nextCount = newCountStr === "" ? 0 : parseInt(newCountStr, 10);
		} else {
			if (isFirstInput) {
				// replace the default 1 with first input
				nextCount = num;
			} else {
				// normal append
				nextCount = Number(countsVKOT.toString() + num.toString());
			}
		}

		if (currentRemainingStock !== undefined && currentRemainingStock !== null && nextCount > currentRemainingStock) {
			alert(`Only ${currentRemainingStock} items available today!`);
			return;
		}

		if (num === "zero") {
			setCount(0);
			setIsFirstInput(true);
		} else if (num === "back") {
			setCount(nextCount);
			if (nextCount === 0) setIsFirstInput(true);
		} else {
			setCount(nextCount);
			if (isFirstInput) setIsFirstInput(false);
		}
	};

	// handle typing in input
	const handleOnChangeCount = (e) => {
		const value = e.target.value;
		if (value === "") {
			setCount("");
			setIsFirstInput(true);
			return;
		}

		let nextCount;
		if (isFirstInput) {
			nextCount = Number(value[value.length - 1]); // only take last typed digit
		} else {
			nextCount = Number(value);
		}

		if (currentRemainingStock !== undefined && currentRemainingStock !== null && nextCount > currentRemainingStock) {
			alert(`Only ${currentRemainingStock} items available today!`);
			return;
		}

		setCount(nextCount);
		if (isFirstInput) setIsFirstInput(false);
	};

	const handleFocus = () => {
		if (countsVKOT === 0) {
			setCount(1);
			setIsFirstInput(true);
		}
	};

	const handleBlur = () => {
		if (countsVKOT === "" || countsVKOT === 0) {
			setCount(1);
			setIsFirstInput(true);
		}
	};

	const handleBack = (e) => {
		e.stopPropagation();
		// Check if `varients` exists and is an array
		const variants = Array.isArray(id.varients) ? id.varients : [];
		setVarientsArray(variants);

		if (variants.length > 0) {
			setShowVariantModal(true);
		} else {
			onClose(false);
		}
	};

	const [addonRemarkModal, setAddonRemarkModal] = useState(false);

	const [addons, setAddons] = useState([]);

	// //(addons);

	const handleGetAddons = async () => {
		setAddonRemarkModal(true);
		try {
			// const response = await axios.get(
			// 	`${api_base_url}/getRecommendedAddonsKOT/${id.id_productReg}/${logginedDB}`
			// );
			// if (response.status == 200) {
			// 	console.log(response.data, "response.data");
			// 	const addondata = response.data
			// 	if (response.data) {
			// 		// setAddonRemarkModal(true)
			// 		setAddons(response.data);
			// 		const initialValuesAddOn = response.data.reduce((acc, addOn) => {
			// 			acc[addOn.id_addon] = 0;
			// 			return acc;
			// 		}, {});
			// 		setCountInputValuesAddOn(initialValuesAddOn);
			// 	} else {
			// 		// setAddonRemarkModal(false)
			// 		// onSave(countsVKOT, selectedVariant, id)
			// 	}
			// }
			const response = await axios.get(
				`${api_base_url}/getRecommendedAddonsKOT/${id.id_productReg}/${logginedDB}`
			);

			if (response.status === 200) {
				console.log(response.data, "response.data");

				// Filter only status = 1
				const filteredAddons = response.data.filter(addOn => addOn.Status === 1);

				if (filteredAddons.length > 0) {
					setAddons(filteredAddons);

					// Initialize counts only for filtered addons
					const initialValuesAddOn = filteredAddons.reduce((acc, addOn) => {
						acc[addOn.id_addon] = 0;
						return acc;
					}, {});
					setCountInputValuesAddOn(initialValuesAddOn);
				} else {
					// No active addons found
					setAddons([]);
					// setAddonRemarkModal(false) // uncomment if you want to auto-close
				}
			}
		} catch (error) {
			//(error);
		}
	};

	const [selectedAddOnInfo, setSelectedAddOnInfo] = useState({});

	const [totalPriceOnCountAddOn, setTotalPriceOnCountAddOn] = useState(0);

	const [countInputValuesAddOn, setCountInputValuesAddOn] = useState({});

	// //(countInputValuesAddOn);

	const handleSave = () => {
		// Check if selectedVariant exists and if there are variants in the array
		if (countsVKOT === 0) {
			alert("Please select quantity before saving!");
			return;
		}

		if (selectedVariant) {
			setAlreadySelectedVariantsFunc(
				id.id_productReg,
				selectedVariant.variantId
			);
		}

		handleGetAddons();
		// Proceed with saving
		// onSave(countsVKOT, selectedVariant, proIdVKOT, selectedAddon);
	};

	const handleCountInputValue = (e, name, Id, price) => {
		const inputValue = e.target.value;

		setCountInputValuesAddOn((prevValues) => {
			// const totalPrice = inputValue * price;
			const updatedValues = {
				...prevValues,
				[Id]: inputValue === "" ? "" : Number(inputValue),
				[`${Id}_price`]: price,
			};

			// Calculate the sum of all prices
			const totalPriceSum = Object.keys(updatedValues)
				.filter((key) => key.endsWith("_price"))
				.reduce((sum, key) => sum + updatedValues[key], 0);

			setTotalPriceOnCountAddOn(totalPriceSum);

			if (inputValue > 0) {
				setSelectedAddOnInfo((prevName) => ({
					...prevName,
					[Id]: {
						name,
						count: inputValue,
					},
				}));
			} else {
				setSelectedAddOnInfo((prevName) => {
					const { [Id]: _, ...rest } = prevName;
					return rest;
				});
			}

			return {
				...updatedValues,
				totalPriceSum,
			};
		});
		// handleitemsNetTotal(totalPriceOnCountVarient,totalPriceOnCountAddOn)
	};

	const handleCountInputValueFocus = (Id) => {
		if (!countInputValuesAddOn[Id]) {
			setCountInputValuesAddOn((prevValues) => ({
				...prevValues,
				[Id]: "",
			}));
		}
	};

	const handleCountInputValueBlur = (variantId) => {
		if (countInputValuesAddOn[variantId] === "") {
			setCountInputValuesAddOn((prevValues) => ({
				...prevValues,
				[variantId]: 0,
			}));
		}
	};

	const handleCountIncrement = (name, Id, price) => {
		setCountInputValuesAddOn((prevValues) => {
			const newCount = (prevValues[Id] || 0) + 1;
			// const totalPrice = newCount * price;
			const updatedValues = {
				...prevValues,
				[Id]: newCount,
				[`${Id}_price`]: price,
			};

			// Calculate the sum of all prices
			const totalPriceSum = Object.keys(updatedValues)
				.filter((key) => key.endsWith("_price"))
				.reduce((sum, key) => sum + updatedValues[key], 0);

			setTotalPriceOnCountAddOn(totalPriceSum);

			if (newCount > 0) {
				setSelectedAddOnInfo((prevName) => ({
					...prevName,
					[Id]: {
						name,
						count: newCount,
					},
				}));
			} else {
				setSelectedAddOnInfo((prevName) => {
					const { [Id]: _, ...rest } = prevName;
					return rest;
				});
			}

			return {
				...updatedValues,
				totalPriceSum,
			};
		});
		// handleitemsNetTotal(totalPriceOnCountVarient,totalPriceOnCountAddOn)
	};

	const handleCountDecrement = (name, Id, price) => {
		setCountInputValuesAddOn((prevValues) => {
			const newCount = Math.max(0, (prevValues[Id] || 0) - 1);
			// const totalPrice = newCount * price;
			const updatedValues = {
				...prevValues,
				[Id]: newCount,
				[`${Id}_price`]: price,
			};

			// Calculate the sum of all prices
			const totalPriceSum = Object.keys(updatedValues)
				.filter((key) => key.endsWith("_price"))
				.reduce((sum, key) => sum + updatedValues[key], 0);

			setTotalPriceOnCountAddOn(totalPriceSum);

			if (newCount > 0) {
				setSelectedAddOnInfo((prevName) => ({
					...prevName,
					[Id]: {
						name,
						count: newCount,
					},
				}));
			} else {
				setSelectedAddOnInfo((prevName) => {
					const { [Id]: _, ...rest } = prevName;
					return rest;
				});
			}

			return {
				...updatedValues,
				totalPriceSum,
			};
		});
	};

	// //("selectedVariant",selectedVariant);
	// //("AddOnInfo",selectedAddOnInfo);
	// //("totalPriceOnCountAddOn",totalPriceOnCountAddOn);

	const [remarks, setRemarks] = useState("");

	const handleRemarks = (e) => {
		const remark = e.target.value;
		setRemarks(remark);
	};

	const handleSaveWithAddon = () => {
		setAddonRemarkModal(false);

		let combined = {};

		if (Object.keys(selectedAddOnInfo).length > 0) {
			combined = Object.keys(selectedAddOnInfo).reduce((acc, key) => {
				const priceKey = `${key}_price`;
				acc[key] = {
					...selectedAddOnInfo[key],
					price: countInputValuesAddOn[priceKey] || 0, // Add price or default to 0
				};
				return acc;
			}, {});
		}

		const addonInfoAndPrice = {
			...combined,
			total: totalPriceOnCountAddOn,
		};

		onSave(countsVKOT, selectedVariant, id, addonInfoAndPrice, remarks);
	};

	const handleCancelAddon = () => {
		onSave(countsVKOT, selectedVariant, id);
	};

	const selectedItemName = selectedVariant
		? `${id?.productName || ""} - ${selectedVariant.variantName}`
		: id?.productName || "";
	const selectedItemAmount = selectedVariant?.variantRate || id?.rate || 0;

	return (
		<div className="w-full h-full flex justify-center items-center font-nunito overflow-hidden">
			{showVariantModal ? (
				<div className="bg-[#465366] rounded-lg text-white w-[25rem] h-[20rem] overflow-hidden">
					{/* <h3>Select a Variant</h3> */}
					<div className="w-full flex text-lg font-semibold text-[1.1rem] bg-[#D9D9D9] px-3 py-2 rounded-t-lg text-black">
						<span className="w-full text-left">
							{id?.productName || "Select a Variant"}
						</span>
						<div className="w-max flex justify-center items-center">
							<img
								className="w-[1rem] cursor-pointer"
								src={Close}
								alt=""
								onClick={() => onClose(false)}
							/>
						</div>
					</div>
					<div className="flex flex-wrap p-3 gap-3 font-[600] overflow-auto">
						{varientsArray.map((variant, index) => (
							<div
								key={index}
								onClick={() => handleVariantSelect(variant)}
								className={`flex flex-col gap-2 cursor-pointer py-3 px-4 text-left rounded-md shadow-md ${alreadySelectedVariants[id.id_productReg]?.includes(
									variant.variantId
								)
									? "bg-[#F40000]"
									: "bg-[#2a2a2a]"
									}`}
							>
								{/* {variant.variantName} - {variant.variantRate} */}
								<span className="">{variant.variantName}</span>
								<span className="">₹ {variant.variantRate}</span>
							</div>
						))}
					</div>
				</div>
			) : (
				// }
				//  {!showVariantModal && (
				<div className="w-full h-full flex justify-center items-center">
					{addonRemarkModal ? (
						<div className="flex flex-col bg-[#465366] rounded-t-lg text-white w-[25rem] h-[20rem] overflow-hidden">
							<div className="w-full h-max flex text-lg font-semibold text-[1.1rem] bg-[#D9D9D9] px-3 py-2 rounded-t-lg text-black">
								<span className="w-full text-left">
									{id?.productName || "Addons"}
								</span>
								<div className="w-max flex justify-center items-center">
									<img
										className="w-[1rem] cursor-pointer"
										src={Close}
										alt=""
										onClick={handleCancelAddon}
									/>
								</div>
							</div>
							<div className="w-full h-full flex flex-col gap-3 p-3 overflow-auto customScroll">
								{addons.length > 0 && (
									<div className="w-full h-full flex flex-col gap-3">
										<div className="w-full h-max underline">Add-ons</div>
										<div className="w-full h-full flex flex-col gap-3 font-[600] overflow-auto customScroll">
											{addons.map((addOn) => (
												<div
													key={addOn.id_addon}
													className="w-full flex justify-center items-center font-[500]"
												>
													<div className="onClickItemWindowPop_ContentDiv_Choose_Varient_VarientDiv_Item">
														{addOn.addon_name}
													</div>
													<div className="onClickItemWindowPop_ContentDiv_Item_Count">
														<div className="w-[30%] flex justify-center items-center cursor-pointer">
															<img
																className="w-[1rem] invert"
																src={minus}
																alt="-"
																onClick={() =>
																	handleCountDecrement(
																		addOn.addon_name,
																		addOn.id_addon,
																		addOn.addon_rate
																	)
																}
															/>
														</div>
														<input
															className="w-[40%] text-center border-none rounded-none bg-transparent"
															type="number"
															value={countInputValuesAddOn[addOn.id_addon]}
															onChange={(e) =>
																handleCountInputValue(
																	e,
																	addOn.addon_name,
																	addOn.id_addon,
																	addOn.addon_rate
																)
															}
															onFocus={() =>
																handleCountInputValueFocus(addOn.id_addon)
															}
															onBlur={() =>
																handleCountInputValueBlur(addOn.id_addon)
															}
														/>
														<div className="w-[30%] flex justify-center items-center cursor-pointer">
															<img
																className="w-[1rem] invert"
																src={plus}
																alt="+"
																onClick={() =>
																	handleCountIncrement(
																		addOn.addon_name,
																		addOn.id_addon,
																		addOn.addon_rate
																	)
																}
															/>
														</div>
													</div>
													<div className="onClickItemWindowPop_ContentDiv_Choose_Varient_VarientDiv_Price">
														<span>
															<img
																className="w-[.75rem]"
																src={Rupee1}
																alt="?"
															/>
															{addOn.addon_rate}
														</span>
													</div>
												</div>
											))}
										</div>
									</div>
								)}
								<div className="w-full h-max flex flex-col gap-3">
									<div className="w-full h-max underline">Remarks</div>
									<div className="w-full h-full flex flex-col gap-3 font-[500]">
										<textarea
											name=""
											id=""
											rows={5}
											className="w-full rounded-[.313rem] bg-transparent text-[#fff] p-2 text-[.9rem] border focus:outline-none"
											value={remarks}
											onChange={handleRemarks}
										></textarea>
									</div>
								</div>
							</div>
							<div className="w-full h-max flex justify-end items-center border-t border-[#D9D9D9] p-3 gap-2">
								<button
									className="bg-[#fff] text-[#000] py-1 px-3 rounded-[.313rem]"
									onClick={handleCancelAddon}
								>
									Cancel
								</button>
								<button
									className="bg-[#2591D1] text-[#fff] py-1 px-3 rounded-[.313rem]"
									onClick={handleSaveWithAddon}
								>
									Save
								</button>
							</div>
						</div>
					) : (
						<div className="w-max h-max relative">
							<div className="w-max h-max flex flex-col gap-2 bg-[#465366] p-3 rounded-lg">
								<div className="w-full flex justify-between items-center gap-4 bg-[#263238] text-white rounded-md px-3 py-2">
									<span className="max-w-[16rem] truncate font-semibold">
										{selectedItemName}
									</span>
									<span className="flex items-center gap-1 font-semibold text-nowrap">
										<img className="w-[.8rem]" src={Rupee1} alt="₹" />
										{selectedItemAmount}
									</span>
								</div>
								<div className="VariantCountKOT_Container_InputCount">
									<input
										type="number"
										value={countsVKOT}
										onChange={(e) => handleOnChangeCount(e)}
										onFocus={handleFocus}
										onBlur={handleBlur}
									/>
								</div>
								<div className="w-full h-max flex flex-col gap-2 text-[#fff]">
									<div className="w-full h-max flex gap-2">
										<div
											className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
											onClick={() => handleOnClickCount(7)}
										>
											7
										</div>
										<div
											className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
											onClick={() => handleOnClickCount(8)}
										>
											8
										</div>
										<div
											className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
											onClick={() => handleOnClickCount(9)}
										>
											9
										</div>
										<div
											className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
											onClick={() => handleOnClickCount(10)}
										>
											+10
										</div>
									</div>
									<div className="w-full h-max flex gap-2">
										<div
											className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
											onClick={() => handleOnClickCount(4)}
										>
											4
										</div>
										<div
											className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
											onClick={() => handleOnClickCount(5)}
										>
											5
										</div>
										<div
											className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
											onClick={() => handleOnClickCount(6)}
										>
											6
										</div>
										<div
											className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
											onClick={() => handleOnClickCount(20)}
										>
											+20
										</div>
									</div>
									<div className="w-full h-max flex gap-2">
										<div className="w-1/4 flex flex-col gap-2">
											<div
												className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
												onClick={() => handleOnClickCount(1)}
											>
												1
											</div>
											<div
												className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
												onClick={() => handleOnClickCount("zero")}
											>
												C
											</div>
										</div>
										<div className="w-1/4 h-max flex flex-col gap-2">
											<div
												className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
												onClick={() => handleOnClickCount(2)}
											>
												2
											</div>
											<div
												className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
												onClick={() => handleOnClickCount(0)}
											>
												0
											</div>
										</div>
										<div className="w-1/4 h-max flex flex-col gap-2">
											<div
												className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
												onClick={() => handleOnClickCount(3)}
											>
												3
											</div>
											<div
												className="w-[6rem] h-[4rem] flex justify-center items-center bg-[#263238] hover:bg-[#14191c] borderCalculator"
												onClick={() => handleOnClickCount("back")}
											>
												<img
													className="VariantCountKOT_Container_third_Col_BackImg"
													src={Back}
													alt="<--"
												/>
											</div>
										</div>
										<div
											className="w-1/4 min-h-full borderCalculator flex justify-center items-center bg-[#257c25c8]"
											onClick={handleSave}
										>
											<span className="text-[#fff]">Save</span>
										</div>
									</div>
								</div>
							</div>
							<div className="absolute right-0 top-0 transform translate-x-[100%]">
								<div
									className="flex justify-center bg-[#c30000] p-3 rounded-lg items-center ml-3"
									type="button"
									onClick={handleBack}
								>
									<img
										className="w-[1rem] invert"
										src={Close}
										alt="Close"
										style={{ pointerEvents: "none" }}
									/>
								</div>
							</div>
						</div>
					)}
				</div>
			)}
		</div>
	);
}

export default VariantCountKOT;
